
export default class CalendarService {

    fetchevents(): Promise<Array<any>> {
        return fetch('api/duty/getcalendar')
            .then(response => response.json() as Promise<Array<any>>);
    }

    fetcheventsRange(startDate, endDate): Promise<Array<any>> {
        var params = { startDate: startDate, endDate: endDate }
        var search = new URLSearchParams(params).toString();

        return fetch('api/duty/getcalendar?' + search)
            .then(response => response.json() as Promise<Array<any>>);
    }
}